import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  toggle() {
    this.menuTarget.classList.toggle("max-h-0")
    this.menuTarget.classList.toggle("max-h-screen")
    this.menuTarget.classList.toggle("opacity-0")
    this.menuTarget.classList.toggle("opacity-100")

    if (window.lucide) {
      window.lucide.createIcons()
    }
  }
}
